import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Container from "@/components/base/Container";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SiteHeader />
      <main className="pt-16 md:pt-20">
        <Container>
          <div className="flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
            <span className="font-heading text-[5rem] font-black leading-none text-background-200 md:text-[8rem]">
              404
            </span>
            <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              这个页面还没有内容
            </h1>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
              你访问的地址不存在或已经被调整。回到首页，继续看网红明星的跨界对比与解读。
            </p>
            <p className="mt-2 break-all text-xs text-foreground-400">{location.pathname}</p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-home-line text-base" />
                </span>
                返回首页
              </Link>
              <Link
                to="/compare"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
              >
                查看对比榜单
              </Link>
            </div>
          </div>
        </Container>
      </main>
      <SiteFooter />
    </>
  );
}